/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, Fragment } from "react";

// antd:
import { Divider } from "antd";
// import { LoadingOutlined } from "@ant-design/icons";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// My Components:
import AppIcons from "../react/AppIcons.tsx";
import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getTheme, getElementState, getUser } from "../../libs/reducer.ts"; // getAppState
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

type TdividerType = {
  type:"horizontal" | "vertical",
  orientation?:"center" | "left" | "right",
  dashed?:boolean,
  plain?:boolean
};

const { rz } = window;

const RZdivider:FC<TuniversalElementProps> = ({attributes}) => {
  RZdivider.displayName = "Divider";
  const user = useAppSelector(getUser);
  const lng = useAppSelector(getLng);
  const rlng = (lng === "en" ? "ru" : "en");
  const theme = useAppSelector(getTheme);

  const {rootAttributes, key, fullPath} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const elState = useAppSelector(getElementState(rootAttributes.key, fullPath)); // value, visible, disabled, loading, userStyle, userClass
  const {color, icon, iconClass, iconColor, iconSize, type, align} = {...attributes, ...elState.attributes};
  // const rootNamespace = useMemo(() => (window[rootAttributes?.key || rz.strMakeID(24)]), [rootAttributes?.key]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    return userClss;
  }, [elState?.userClass, elState?.disabled, permissions]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    let clr:string; const allc = (color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) {
      est.color = clr;
      est.borderTopColor = clr;
      est.borderInlineStartColor = clr;
      est.borderLeftColor = clr;
    }
    return est;
  }, [elState?.userStyle, elState?.visible, color, theme, permissions]);

  const dtype = useMemo<TdividerType>(() => {
    const typ:TdividerType = {type: "horizontal", dashed: false, plain: false};
    (type || "").toLowerCase().replace((/(\s+|,|\|)/igm), ";").split(";").forEach((tt) => {
      if (~["horizontal", "vertical"].indexOf(tt)) { typ.type = tt }
      else if (~["left", "center", "right"].indexOf(tt)) { typ.orientation = tt }
      else if (tt === "dashed") { typ.dashed = true }
      else if (tt === "plain") { typ.plain = true }
    });
    return typ;
  }, [type]);

  const rico = useMemo(() => {
    let ico:React.ReactElement | undefined;
    if (icon) { ico = (<AppIcons key={key + "-icon"} icopath={icon} attrs={{className: iconClass || "rz-margin-right-5", color: iconColor, size: iconSize}} />) }
    return ico;
  }, [key, icon, iconClass, iconColor, iconSize]);

  // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
  const title = useMemo<string | undefined>(() => (elState?.value || elState.attributes["title_" + lng] || elState.attributes.title || elState.attributes["title_" + rlng] || attributes["title_" + lng] || attributes.title || attributes["title_" + rlng]), [elState.value, elState.attributes, attributes, lng]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tooltip = useMemo<string | undefined>(() => (elState.attributes["tooltip_" + lng] || elState.attributes.tooltip || elState.attributes["tooltip_" + rlng]), [elState.attributes, lng]);

  return (
    <Divider key={key} className={clsu.join(" ")} style={styl} uk-tooltip={tooltip}
      orientation={align || dtype.orientation}
      type={dtype.type}
      dashed={dtype.dashed}
      plain={dtype.plain} // no text formatting
    >
      {rico || title
        ? (<React.Fragment key={key + "-frgm"}>{rico}{title ? (<span className={icon ? "rz-padding-right-5" : ""}>{title}</span>) : undefined}</React.Fragment>)
        : undefined
      }
    </Divider>
  );
}

export default RZdivider;
/* eslint-enable @typescript-eslint/no-unused-vars */
